import React from 'react';
import { Col, Row } from 'react-bootstrap';

const NexersysLocationWidget = (props: any) => {
  return (
    <div className="nexersys-locationwidget-background">
      <div className="container">
        <Row md={2} xs={1} sm={1}>
          <Col className="address" >

            <div className="addresscolor" dangerouslySetInnerHTML={{ __html: props.data.companyAddress }} />

          </Col>
          <Col>
            <iframe
              title="maps"
              className="maps"
              src="https://maps.google.com/maps?q=7500%20Rialto%20Blvd%2C%20Bldg%201%20Ste%20122%2C%20Austin%2C%20TX%2078735&t=m&z=15&output=embed&iwloc=near"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NexersysLocationWidget;
